import { api } from './api';

export type AiResultKind = 'search' | 'compose' | 'brief' | 'compare' | 'audit' | 'workflow' | 'research';

export interface AiResult {
  id: string;
  kind: AiResultKind;
  title: string;
  input: Record<string, unknown>;
  output: string;
  citedChunkIds: string[];
  model: string | null;
  costCents: number | null;
  pinned: boolean;
  createdAt: string;
}

export interface SaveAiResultBody {
  kind: AiResultKind;
  title: string;
  output: string;
  input?: Record<string, unknown>;
  citedChunkIds?: (string | number)[];
  model?: string;
  costCents?: number;
}

export const aiResultsApi = {
  async list(workspaceId: string, kind?: AiResultKind): Promise<AiResult[]> {
    const r = await api.get<AiResult[]>(`/api/workspaces/${workspaceId}/ai-results`, {
      params: kind ? { kind } : undefined,
    });
    return r.data;
  },
  async get(workspaceId: string, id: string): Promise<AiResult> {
    const r = await api.get<AiResult>(`/api/workspaces/${workspaceId}/ai-results/${id}`);
    return r.data;
  },
  async save(workspaceId: string, body: SaveAiResultBody): Promise<AiResult> {
    const r = await api.post<AiResult>(`/api/workspaces/${workspaceId}/ai-results`, body);
    return r.data;
  },
  async pin(workspaceId: string, id: string, pinned: boolean): Promise<AiResult> {
    const r = await api.post<AiResult>(`/api/workspaces/${workspaceId}/ai-results/${id}/pin`, { pinned });
    return r.data;
  },
  async remove(workspaceId: string, id: string): Promise<{ ok: boolean }> {
    const r = await api.delete<{ ok: boolean }>(`/api/workspaces/${workspaceId}/ai-results/${id}`);
    return r.data;
  },
};
